import { render, staticRenderFns } from "./InstrumentType.vue?vue&type=template&id=03a494f9&"
import script from "./InstrumentType.vue?vue&type=script&lang=js&"
export * from "./InstrumentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports